var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMergeTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757575",
    fillRule: "nonzero",
    d: "M18.013 3.3c-.62 0-1.034.55-1.034 1.21V15.4c0 .66.414 1.1 1.034 1.21.62 0 1.035-.55 1.035-1.21V4.51c0-.66-.414-1.21-1.035-1.21zM14.29 0H2.084C1.153 0 .429.77.429 1.76v15.18c0 .99.724 1.76 1.655 1.76h1.448v2.2c0 .66.413 1.1 1.034 1.1h6.206c.621 0 1.035-.44 1.035-1.1v-2.2h2.482c.931 0 1.655-.77 1.655-1.76V1.76C15.944.77 15.22 0 14.29 0zM2.497 6.6h3.104v2.2H2.497V6.6zm7.241 3.3v2.2H6.635V9.9h3.103zM6.635 8.8V6.6h3.103v2.2H6.635zm3.103 4.4v2.2H6.635v-2.2h3.103zm-7.24-3.3H5.6v2.2H2.497V9.9zm0 5.5v-2.2H5.6v2.2H2.497zM5.6 20.9H4.566v-2.2h1.035v2.2zm5.171 0H7.67v-2.2h3.103v2.2zm3.104-5.5h-3.104v-2.2h3.104v2.2zm0-3.3h-3.104V9.9h3.104v2.2zm0-3.3h-3.104V6.6h3.104v2.2zm0-4.4H2.497V2.2h11.379v2.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeTransaction);
export default __webpack_public_path__ + "static/media/MergeTransaction.746ceaa8.svg";
export { ForwardRef as ReactComponent };